import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SharedService } from './shared.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PluginStoresService {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(error as T);
    };
  }

  getAllPluginStores(filter: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/plugin/stores', filter, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllPluginStores', []))
    );
  }

  createPluginStore(value: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/plugin/store' , value, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createPluginStore', []))
    );
  }

  getPluginStore(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'admin/plugin/store/'+id,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getPluginStore', []))
    )
  }
  
}
